import React, { useEffect } from 'react';
import { Button, LoadingButton, ModalHeader, ModalBody, ModalFooter, Typography, } from '@one-thd/sui-atomic-components';
import { getCardImagePath } from '../../../utils/credit-cards';
import { track, setOverlayEvent } from '../../../utils/analytics';
const ConfirmHDWalletRemovalSection = ({ card, isHDPassForPurchasers, }) => {
    const { cardBrand, cardType, cardNumberLast4, cardExpiryMonth, cardExpiryYear, } = card;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-flex sui-flex-wrap sui-mb-6 sui-items-center" },
            React.createElement("img", { width: 50, height: "auto", className: "sui-inline-block sui-mr-4", src: getCardImagePath(cardBrand, cardType), alt: "Credit card logo" }),
            React.createElement("div", { className: "sui-mr-4" },
                React.createElement(Typography, { variant: "body-lg", color: "subtle" },
                    "****",
                    cardNumberLast4)),
            cardExpiryMonth && cardExpiryYear && (React.createElement(Typography, { variant: "body-lg", color: "subtle" }, `Exp ${cardExpiryMonth}/${cardExpiryYear.slice(-2)}`))),
        !isHDPassForPurchasers && (React.createElement("div", { className: "sui-mb-6" },
            React.createElement(Typography, { variant: "body-base" }, "This card may be in use for one or more users with HD Pass."))),
        React.createElement("div", { className: "sui-mb-6" },
            React.createElement(Typography, null, "Removing HD Pass authorization will stop in-store purchases with this card using HD Pass."))));
};
export const RemoveHDWalletModal = ({ card, hideModal, onConfirmRemove, isLoading, isHDPassForPurchasers, }) => {
    useEffect(() => {
        setOverlayEvent('hdpass remove card');
    }, []);
    const onClickNoButton = () => {
        track('home-depot-wallet.actions.remove-hd-pass-button-click', {
            buttonType: 'no',
        });
        hideModal();
    };
    const onClickYesButton = () => {
        track('home-depot-wallet.actions.remove-hd-pass-button-click', {
            buttonType: 'yes remove this card',
        });
        onConfirmRemove();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: onClickNoButton }, "Do You Want To Remove HD Pass Authorization For This Credit Card?"),
        React.createElement(ModalBody, null,
            React.createElement(ConfirmHDWalletRemovalSection, { card: card, isHDPassForPurchasers: isHDPassForPurchasers })),
        React.createElement(ModalFooter, null,
            React.createElement("div", { className: "sui-flex sui-whitespace-nowrap sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row" },
                React.createElement(Button, { variant: "secondary", fullWidth: true, onClick: onClickNoButton }, "No"),
                React.createElement(LoadingButton, { variant: "primary", loading: isLoading, fullWidth: true, onClick: onClickYesButton, "data-testid": "stop-auth-this-cards-btn" }, "Yes, Remove for This Card")))));
};
RemoveHDWalletModal.displayName = 'RemoveHDWalletModal';
